import React from "react";
import { dateTimeMask } from "../../common/dateMask";
import "./style/shipping-route-print.css";
import { formatFinance } from "../../utils/formatters";

const ShippingRouteDetailsTicket = ({
  shippingRoute,
  componentRef,
  onOrderClick,
  forPrinting = false,
}) => {
  if (!shippingRoute) {
    return null;
  }

  return (
    <div ref={componentRef} className="shipping-route-container">
      <div className="shipping-route-paper">
        {/* Header */}
        <div className="shipping-route-header">
          <div className="shipping-route-title-container">
            <h1 className="shipping-route-title">
              {shippingRoute?.driver?.name
                ? `${shippingRoute.driver.easy_id} - ${shippingRoute.driver.name}`
                : "Detalhes da Entrega"}
            </h1>
          </div>

          {shippingRoute?.dispatched_at && (
            <div className="shipping-route-subtitle-container">
              <p className="shipping-route-subtitle">
                {dateTimeMask(shippingRoute.dispatched_at)}
              </p>
            </div>
          )}
        </div>

        <hr className="shipping-route-divider" />

        {/* Orders list */}
        {shippingRoute?.shipping_routes_orders &&
        shippingRoute.shipping_routes_orders.length > 0 ? (
          <ul className="shipping-route-list">
            {shippingRoute.shipping_routes_orders.map((order, index) => (
              <li
                key={`shipping-routes-orders-${order.fk_order.order_index}`}
                className="shipping-route-list-item"
              >
                <div className="shipping-route-order-paper">
                  <div
                    className="shipping-route-order-container"
                    onClick={
                      forPrinting
                        ? undefined
                        : () => onOrderClick(order.fk_order.order_id)
                    }
                  >
                    <div className="shipping-route-order-header">
                      <div className="shipping-route-order-header-left">
                        <span
                          className={`shipping-route-order-number ${
                            order.is_main_order
                              ? "shipping-route-order-main"
                              : ""
                          }`}
                        >
                          {order.fk_order.order_index}
                        </span>
                        <h2 className="shipping-route-order-title">
                          Pedido {order.fk_order.order_index}
                        </h2>
                      </div>
                      <span
                        className={`shipping-route-order-badge ${
                          order.is_main_order
                            ? "shipping-route-order-badge-main"
                            : ""
                        }`}
                      >
                        {order.is_main_order ? "Principal" : "Rota"}
                      </span>
                    </div>

                    <div className="shipping-route-order-row">
                      <p className="shipping-route-order-address">
                        {order.fk_order.address}
                      </p>
                    </div>

                    <div className="shipping-route-order-row-between">
                      <div className="shipping-route-order-row">
                        <p className="shipping-route-order-time">
                          {dateTimeMask(order.created_at)}
                        </p>
                      </div>

                      <div className="shipping-route-order-row">
                        <p className="shipping-route-order-price">
                          {formatFinance(order.delivery_tax / 100)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="shipping-route-empty">
            <p className="shipping-route-empty-text">Não há pedidos na rota</p>
          </div>
        )}

        <hr className="shipping-route-divider" />

        {shippingRoute.equipment && (
          <>
            <div className="shipping-route-footer">
              <p className="shipping-route-total">
                Maquininha : {shippingRoute.equipment.name}
              </p>
            </div>
            <hr className="shipping-route-divider" />
          </>
        )}

        {shippingRoute.change !== 0 && (
          <>
            <div className="shipping-route-footer">
              <p className="shipping-route-total">
                A devolver : {formatFinance(shippingRoute.change)}
              </p>
            </div>
            <hr className="shipping-route-divider" />
          </>
        )}

        <div className="shipping-route-footer">
          <p className="shipping-route-total">
            Total:{" "}
            {formatFinance((shippingRoute?.total_delivery_tax || 0) / 100)}
          </p>
        </div>

        <hr className="shipping-route-divider" />

        <div className="shipping-route-footer">
          <div className="shipping-route-driver">
            <h2 className="shipping-route-driver-name">
              {shippingRoute?.driver?.name
                ? `${shippingRoute.driver.easy_id} - ${shippingRoute.driver.name}`
                : "Fim do Relatório"}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingRouteDetailsTicket;
